<template>
    <SwapMenu2 :swapid="swapid" :period="period" title="Swap Data" margin="1">
      <template v-slot:menu>
        <li><a v-if="interval == 0" 
            class="dropdown-item" @click=start_interval()>Start Interval</a></li>
        <li><a v-if="interval > 0" 
            class="dropdown-item" @click=stop_interval()>Stop Interval</a></li>
      </template>
    </SwapMenu2>
    <div class="container divstyle">
        <table class="table table-striped table-bordered font-custom">
            <thead>
                <tr>
                    <th class="aligncenter" colspan=4>LAST START: {{starttime}}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="data in txdata" :key="data[0]">
                    <td class="colpad">{{ data[0] }}</td>
                    <td class="colpad">{{ data[1] }}</td>
                    <td class="colpad">{{ data[2] }}</td>
                    <td class="colpad">{{ data[3] }}</td>
                </tr>
            </tbody>
        </table>
    </div>    
</template>

<style scoped>
.font-custom {
    font-size : 10pt ;
    text-align: left ;
}
.colpad {
    padding: 0.1rem !important ;
    font-size: 10pt ;
    text-align : left ;
    white-space: nowrap ;
    overflow : auto ;
}
.divstyle {
    font-size : 10pt ;
    max-height: 300px ;
    overflow-y: auto;
    margin-top: 0px ;
}
.aligncenter {
    text-align: center ;
}
</style>

<script>
import txdatatab from '../assets/txdata.json' 
import SwapMenu2 from './SwapMenu2.vue' 

export default {
  name: 'SwapData',
  components: {
      SwapMenu2
  },
  props: {
    period : Number,
    globid : String,
    swapid : String,
    screensize : String
  },
  data() {
    return {
        interval : 0,
        status : '', 
        xcount  : 300 
    }
  },
  mounted() {
      this.start_interval();
  },
  unmounted() {
      this.stop_interval();
  },
  computed : {
      txdata() {
        let swap = this.$store.getters.getswap_byid (parseInt(this.swapid)) ;
        if (! swap || ! swap.sdata || !swap.sdata.txdata) 
            return [ [ "lab1", "nul1", "lab2", "nul2" ] ] ;

        let grparr = []
        let newrow = []

        // format array of 4 column data
        let insarray = ( lab, data ) => {
            if (newrow.length == 0) {
                newrow.push (lab) ;
                newrow.push (data) ;
            }
            else {
                newrow.push (lab) ;
                newrow.push (data) ;
                grparr.push (newrow)        // contain 4 entries
                newrow = [] ;
            }
        }

        let objarr = Object.entries(swap.sdata.txdata) ;    // array of tuple 
        // want to format to 
        for (let i = 0 ; i < objarr.length ; i++) {
            let lab = objarr[i][0] ;
            if (lab == "c126" || lab == "c127") continue ; // start & cur time
            if ( lab.startsWith ("c") )        // rename all with c starting
              insarray (txdatatab[lab], objarr[i][1] ) ;
            else if (lab != "starttime") 
              insarray (lab, objarr[i][1]) ;
            if (this.heightclass() == "1" && i > 20)
                break ;
        }
        if (newrow.length == 0) insarray("padlab", "paddata")  ;
        return grparr ;
      },
      starttime() {
         let swap = this.$store.getters.getswap_byid (parseInt(this.swapid)) ;
         if (typeof swap.sdata == "undefined" || swap.sdata.RC != "00") return "SWAP DOWN" ;
         if (typeof swap.sdata.txdata == "undefined")
            return "undefined" ;
         return swap.sdata.txdata.starttime ;
      }
  },
  methods : {
      widthclass() {
        if (this.screensize.length == 3)
            return this.screensize.substr(2) ;
        else return "1" ;
      },
      heightclass() {
        if (this.screensize.length == 3)
            return this.screensize.substr(0,1) ;
        else return "1" ;
     },
     stop_interval() {
         if (this.interval) {
            clearInterval(this.interval) ;
            this.interval = 0 ;
         }
     },
     start_interval() {
         if (this.interval == 0) {
            this.interval = setInterval( () => 
            { this.$store.commit("reqswapdata",  this.swapid)}, this.period) ;
         }
     },
  }
}
// vim:expandtab:smartindent:tabstop=4:softtabstop=4:shiftwidth=4:
</script>


